import * as types from './mutations-type';

// actions are functions that cause side effects and can involve
// asynchronous operations.

export default {
  showMessage({commit}, content) {
    commit(types.SET_MESSAGE, content);
  },
  setLoading({commit, dispatch}, loading) {
    commit(types.SET_LOADING, loading);    
    dispatch('clearMessages');
  },
  clearMessages({commit}) {
    commit(types.SET_MESSAGE, "");
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js